// POM-6111 — the reason an admin gives when a physical count or a manual adjustment touches a lot
// carrying an unverified (negative) balance.
//
// Every code MUST exist in core's InventoryAdjustmentReasonCode enum: the API takes it as a
// GraphQL enum, so anything else is rejected before it reaches the service. No "Other" option —
// this is the column the audit report groups on, and a free-text bucket defeats that. The notes
// field on each dialog stays available and optional for anything the code cannot carry.
//
// Unlike Add Stock (see tallyReasons.js), this list includes the WRITE-OFF codes. A count or an
// adjustment is the moment the pharmacy can learn that claimed stock does not exist at all, and
// those codes close the claim WITHOUT ever crediting the verified bucket. Recording a receipt
// cannot mean that, which is why the two lists differ.
//
// The write-off codes are NOT offered on the UI for now. They stay listed (and core still accepts
// them) so turning them back on is flipping WRITE_OFF_REASONS_ENABLED, not re-deriving the list.
const WRITE_OFF_REASONS_ENABLED = false;

const ALL_UNVERIFIED_REASON_OPTIONS = [
  // Stock turned out to be real.
  { code: 'COUNTED_PRESENT', label: 'Found on shelf — stock is real' },
  { code: 'MISSED_RECEIPT', label: 'Missed receipt — record was never entered' },
  { code: 'NEW_SHIPMENT', label: 'New shipment of the same lot' },
  { code: 'FACILITY_TRANSFER', label: 'Transfer from another pharmacy not recorded' },
  // Stock is NOT real — closes the claim without crediting it.
  { code: 'NEVER_EXISTED', label: 'Never existed — scanned in error', writeOff: true },
  { code: 'BREAKAGE', label: 'Breakage', writeOff: true },
  { code: 'DAMAGE', label: 'Damage', writeOff: true },
];

const UNVERIFIED_REASON_OPTIONS = ALL_UNVERIFIED_REASON_OPTIONS.filter(
  (option) => WRITE_OFF_REASONS_ENABLED || !option.writeOff
);

export default UNVERIFIED_REASON_OPTIONS;
